/** Persisted briefly so routes stay mounted while `user` storage is cleared. */
export const SESSION_ENDED_HOLD_KEY = '__gh_session_ended_ui';

const AUTH_PATH_PREFIXES = ['/login', '/resetPassword', '/passwordChanged'];

export function isAuthPathForSessionEndedSkip(pathname) {
    if (!pathname) return false;
    return AUTH_PATH_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

export const SESSION_ENDED_EVENT = 'gh-session-ended';

/**
 * Notifies the app to show the session-ended modal (after storage is cleared with session-ended hold).
 * @param {{ accountStatus?: string, statusMessage?: string, wholesalerName?: string }} [detail]
 */
export function fireSessionEndedUI(detail = {}) {
    if (typeof window === 'undefined') return;
    if (isAuthPathForSessionEndedSkip(window.location.pathname || '')) return;
    window.dispatchEvent(new CustomEvent(SESSION_ENDED_EVENT, { detail }));
}
